import * as React from "react";
import { DeleteButton, SearchTablePage } from "../../../../components";
import { ButtonContainer, IDataTableColumn, showError, showSuccess } from "nsitools-react";
import { CoupleInbreedingApi, CoupleInbreedingGridDto } from "../../../../api";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { useEventsContext } from "../../../../contexts";
import { Checkbox, Icon } from "@blueprintjs/core";

export interface ICoupleInBreedingListProps {
  dogId: number;
}

export const CoupleInBreedingList: React.FunctionComponent<ICoupleInBreedingListProps> = ({ dogId }) => {
  const api = useApiService(CoupleInbreedingApi);
  const { dispatchEvent } = useEventsContext();

  const [deleteLoading, setdeleteLoading] = React.useState([]);

  const deleteCoupleInbreeding = React.useCallback(
    async (coupleInbreedingId: number) => {
      let loading = deleteLoading;
      loading.push(coupleInbreedingId);
      setdeleteLoading([...loading]);
      try {
        await api.delete(coupleInbreedingId);
        showSuccess(t(ETLCodes.DeleteSuccess));
      } catch {
        showError(t(ETLCodes.Error));
      } finally {
        loading = loading.filter((d) => d != coupleInbreedingId);
        setdeleteLoading([...loading]);
        dispatchEvent("RefreshSearchTables");
      }
    },
    [deleteLoading, api]
  );

  const { t } = useTl();

  const columns = React.useMemo<IDataTableColumn<CoupleInbreedingGridDto>[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: CoupleInbreedingGridDto) => (
          <ButtonContainer>
            <DeleteButton
              minimal={true}
              onDelete={() => deleteCoupleInbreeding(row.coupleInbreedingId)}
              loading={deleteLoading.find((d) => d === row.coupleInbreedingId)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Father),
        fieldName: "fatherName",
      },
      {
        header: () => t(ETLCodes.Mother),
        fieldName: "motherName",
      },
      {
        header: () => t(ETLCodes.Inbreeding),
        fieldName: "inbreedingPercentage",
        render: (row) => <div>{row.inbreedingPercentage} %</div>,
      },
      {
        header: () => t(ETLCodes.HasFile),
        fieldName: "hasFile",
        render: (row) => <Checkbox checked={row.hasFile} />,
      },
    ],
    []
  );

  const searchFunction = React.useCallback((sObj) => api.baseSearch({ ...sObj, dogId: dogId }), [api]);

  return (
    <SearchTablePage
      withCard={false}
      columns={columns}
      searchFunction={searchFunction}
      sortKeys={{ coupleInbreedingId: "DESC" }}
    />
  );
};
